import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgMm = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="flag-icons-mm"
    viewBox="0 0 640 480"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill="#fecb00" d="M0 0h640v480H0z" />
    <path fill="#34b233" d="M0 160h640v320H0z" />
    <path fill="#ea2839" d="M0 320h640v160H0z" />
    <g transform="translate(320 256.9)scale(176.87999)">
      <path id="mm-a" fill="#fff" d="m0-1 .3 1h-.6z" />
      <use
        xlinkHref="#mm-a"
        width="100%"
        height="100%"
        transform="rotate(-144)"
      />
      <use
        xlinkHref="#mm-a"
        width="100%"
        height="100%"
        transform="rotate(-72)"
      />
      <use
        xlinkHref="#mm-a"
        width="100%"
        height="100%"
        transform="rotate(72)"
      />
      <use
        xlinkHref="#mm-a"
        width="100%"
        height="100%"
        transform="rotate(144)"
      />
    </g>
  </svg>
);
export default SvgMm;
